import { AxiosInstance } from 'axios';
import { NousContacterInput, UtilitairesApiFactory } from './swagger';

export interface IApi {
  postNousContacter(params: NousContacterInput): Promise<number>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const contactApi = UtilitairesApiFactory({}, endpoint, axiosClient);
  const postNousContacter = (params: NousContacterInput): Promise<number> =>
    new Promise((resolve, reject) => {
      contactApi
        .nousContacter(params)
        .then((response) => {
          resolve(response.status);
        })
        .catch((error: any) => reject(error));
    });
  return { postNousContacter };
};

export default create;
